<div [formGroup]='parent' class="questionGaps">
  <div
    [ngClass]="pageName === 'activities-of-daily-living' || pageName === 'dependant-activities-of-daily-living' ? 'normal-ques-style' : 'normal-ques-style mb-10' ">
    <span class="mar-top-5"> {{question.questionText}} </span>
    @if (question.helpText) {
      <span class="info-icon d-view" >
        <app-tool-tip-notification [childId]="'dropdownStandard'" [tooltipData]="initializeToolTipDateComp(question)" (displayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
        </app-tool-tip-notification>
      </span>
    }
    @if (question.helpText) {
      <span class="info-icon mt-view" >
        <app-tool-tip-notification [childId]="'dropdownStandard'" [tooltipData]="initializeToolTipDateComp(question)" (displayMobileTooltipEmitter)="displayMobileTooltipReceiver()">
        </app-tool-tip-notification>
      </span>
    }
  </div>
</div>